export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

export const maxLengthPolicies = {
  name: 104,
  nameShortDisplay: 20,
  email: 254,
  password: 128,
  team: 50,
  slug: 50,
  domain: 253,
  domains: 1024,
  apiKeyName: 64,
  webhookDescription: 100,
  webhookEndpoint: 2083,
  summary: 1000,
  subject: 40
};
